import { render, staticRenderFns } from "./HealthrecordsAdd.vue?vue&type=template&id=5c0aff88&"
import script from "./HealthrecordsAdd.vue?vue&type=script&lang=js&"
export * from "./HealthrecordsAdd.vue?vue&type=script&lang=js&"
import style0 from "./HealthrecordsAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports